<template>
  <div class="tabbar" style="background-color: #fff;">
    <app-vue class="app-vue" v-if="token" />
    <van-tabbar
      class="container"
      :class="[showTabbar && token ? 'van-tabbar-fixed' : 'van-tabbar-fixede']"
      active-color="#FD4545"
      inactive-color="#333030"
      :z-index="100"
      :safe-area-inset-bottom="false"
      route
    >
      <van-tabbar-item to="/">
        <span class="tab-name">首页</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons.homeActive : icons.home"
        />
      </van-tabbar-item>
      <van-tabbar-item to="/pushLessons">
        <span class="tab-name">推客</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons.pushLessonsActive : icons.pushLessons"
        />
      </van-tabbar-item>
      <!-- <van-tabbar-item class="vip-area" to="/column/family">
        <img
          class="icon"
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons.vipActive : icons.vip"
        />
      </van-tabbar-item> -->
      <van-tabbar-item to="/life/index">
        <span class="tab-name">爱家</span>
        <img
          :class="[props.active ? 'icon-active' : '']"
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons.lifeActive : icons.life"
        />
      </van-tabbar-item>
      <van-tabbar-item to="/study">
        <span class="tab-name">已购</span>
        <img
          :class="[props.active ? 'icon-active' : '']"
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons.purchasedActive : icons.purchased"
        />
      </van-tabbar-item>
      <van-tabbar-item to="/my/index">
        <span class="tab-name">我的</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icons.myActive : icons.my"
        />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import appVue from '@/components/common/app'

export default {
  components: {
    appVue
  },
  data() {
    return {
      icons: {
        home: require('../../assets/images/bar/newhome1.png'),
        homeActive: require('../../assets/images/bar/newhome_active1.png'),
        askAnswer: require('../../assets/images/bar/newquestions1.png'),
        askAnswerActive: require('../../assets/images/bar/newquestions_active1.png'),
        purchased: require('../../assets/images/bar/purchased1.png'),
        purchasedActive: require('../../assets/images/bar/purchased_active1.png'),
        my: require('../../assets/images/bar/newmy1.png'),
        myActive: require('../../assets/images/bar/newmy_active1.png'),
        life: require('../../assets/images/bar/newlife1.png'),
        lifeActive: require('../../assets/images/bar/newlife_active1.png'),
        pushLessons: require('../../assets/images/bar/pushlessons.png'),
        pushLessonsActive: require('../../assets/images/bar/pushlessons_active.png')
      }
    }
  },
  computed: {
    ...mapState({
      showTabbar: state => state.common.showTabbar,
      token: state => state.user.token
    })
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/global.less';
.app-vue {
  padding-top: 50px;
  background-color: transparent;
}
.container {
  transition: all 0.5s;
  height: 134 / @r;
  background-color: #f8f8f8 !important;
  * {
    font-size: 24 / @r;
  }
  .icon-active {
    width: 60 / @r;
    height: 60 / @r;
  }
  img {
    width: 56 / @r;
    height: 56 / @r;
  }
  .van-tabbar-item--active {
    font-weight: 600;
  }
  .vip-area {
    flex-direction: column;
    align-items: center;
    /deep/.van-tabbar-item__icon {
      margin-bottom: 0;
      img {
        width: 88 / @r;
        height: 88 / @r;
      }
    }
  }
}
.van-tabbar-fixed {
  margin-bottom: calc(env(safe-area-inset-bottom) / 2);
  bottom: 100 / @r;
}
.van-tabbar-fixede {
  bottom: 0;
  padding-bottom: calc(env(safe-area-inset-bottom) / 2);
}
</style>
